import { render, staticRenderFns } from "./input-business-info.vue?vue&type=template&id=49938ab1&scoped=true&"
import script from "./input-business-info.vue?vue&type=script&lang=js&"
export * from "./input-business-info.vue?vue&type=script&lang=js&"
import style0 from "./input-business-info.vue?vue&type=style&index=0&id=49938ab1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49938ab1",
  null
  
)

export default component.exports